import { OriginDestinationRateTable } from "../../../dispatch/src/rates/OriginDestinationRateTable";
import { TableComment } from "../../../general/src/TableComment";
import { ProspectActionList } from "../ProspectActionList";
import { Button, DataHeader, DataSource, Label, Layout, Panel, Tab, Table, Tabset, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutOpportunity extends Layout {
    buttonFindNear: Button;
    buttonMarketPlan: Button;
    dataheaderHeader: DataHeader;
    labelODRateSection: Label;
    layoutOrigDestRates: OriginDestinationRateTable;
    layoutTableActivities: ProspectActionList;
    layoutTableComment: TableComment;
    panelGeneral: Panel;
    panelSecondaryFilters: Panel;
    sourceComments: DataSource;
    sourceOpportunity: DataSource;
    sourceOriginDestinationRate: DataSource;
    sourceOtherChargeRate: DataSource;
    sourceProspectAction: DataSource;
    tabActivities: Tab;
    tabCharges: Tab;
    tabComments: Tab;
    tableOtherChargeRate: Table;
    tabsetOptionals: Tabset;
    textboxCollectionMethod: Textbox;
    textboxCommodityId: Textbox;
    textboxConfidenceLevel: Textbox;
    textboxCurrency: Textbox;
    textboxCustomerId: Textbox;
    textboxEffectiveDate: Textbox;
    textboxExpectedClose: Textbox;
    textboxExpirationDate: Textbox;
    textboxId: Textbox;
    textboxIntrastate: Textbox;
    textboxMarkPlanId: Textbox;
    textboxMinimumWeight: Textbox;
    textboxMode: Textbox;
    textboxOpportunityAmt: Textbox;
    textboxOpportunityName: Textbox;
    textboxOpportunityStatus: Textbox;
    textboxOrderType: Textbox;
    textboxPrimaryContact: Textbox;
    textboxSalesManager: Textbox;
    textboxSalesStatusId: Textbox;
    textboxSalespersonId: Textbox;
    textboxTieredTable: Textbox;
    textboxTractorType: Textbox;
    textboxTrailerType: Textbox;
}
